// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/" + {"1039":"menu_desktop","1491":"menu_mobile","9373":"mod_ps_searchbar"}[chunkId] + ".7415992656.bundle.js";
};